import Logo from "./Logo";
import { scrollToId } from "../data/projects";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-ink">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div>
            <div>
              <Logo className="h-12 w-auto rounded-md" />
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/50">
              Architectural renovation &amp; remodeling specialists. Kitchens,
              bathrooms, decks and artisan finishes — built to outlast trends.
            </p>
          </div>
          <div className="flex gap-16">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-copper">Explore</p>
              <div className="mt-4 flex flex-col gap-3">
                {["services", "portfolio", "process", "contact"].map((id) => (
                  <button
                    key={id}
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToId(id)}
                    className="text-left text-sm capitalize text-cream/60 transition-colors hover:text-copper"
                  >
                    {id}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-copper">Studio</p>
              <div className="mt-4 flex flex-col gap-3 text-sm text-cream/60">
                <span>Philadelphia, PA</span>
                <a href="mailto:build@jobaconstruction.com" className="transition-colors hover:text-copper">
                  build@jobaconstruction.com
                </a>
                <a href="tel:+12673468487" className="transition-colors hover:text-copper">
                  +1 (267) 346-8487
                </a>
                <a href="tel:+12152818089" className="transition-colors hover:text-copper">
                  +1 (215) 281-8089
                </a>
                <a href="tel:+12677451243" className="transition-colors hover:text-copper">
                  +1 (267) 745-1243
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-line pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-xs text-cream/40">
            © {new Date().getFullYear()} Joba Construction. All rights reserved.
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-cream/40">
            Built to outlast trends
          </p>
        </div>
      </div>
    </footer>
  );
}
